import { PromoAnalyticsService } from '@analytics/feature';
import { ChangeDetectionStrategy, Component, Optional } from '@angular/core';
import { CustomCmsBannerComponent } from '@promo/const';
import { CmsComponentData, PageSlotComponent } from '@spartacus/storefront';
import { SdSimpleBannerComponent } from '../simple-banner/simple-banner.component';

@Component({
  selector: 'sd-catalog-banner',
  templateUrl: './catalog-banner.component.html',
  styleUrls: ['./catalog-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SdCatalogBannerComponent extends SdSimpleBannerComponent {
  constructor(
    // TODO: Неверная типизация, и похоже компонент должен наследоваться не от SdSimpleBannerComponent, а от SdSimpleResponsiveBannerComponent
    public component: CmsComponentData<CustomCmsBannerComponent>,
    promoAnalyticsService: PromoAnalyticsService,
    @Optional() parent: PageSlotComponent,
  ) {
    super(component, promoAnalyticsService, parent);
  }
}
